// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__HJ2p6"};